export enum DuplicateEntityType {
  TASK = 'TASK',
  APPOINTMENT = 'APPOINTMENT',
  CALL_MEMO = 'CALL_MEMO',
  NOTE = 'NOTE',
  SALES_OPPORTUNITY = 'SALES_OPPORTUNITY',
  ARTICLE = 'ARTICLE',
}
